'use client';

import { CircleHelp } from 'lucide-react';

import type { Driver } from '@ria-client/supergraph/review/schema/types';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@ria-client/tw-shadcn/components/dialog';

export interface ReviewMobileDetailsDialogProps {
  drivers: Driver[];
  title: string;
}

export function ReviewMobileDetailsDialog({ drivers, title }: ReviewMobileDetailsDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          className="typography-text-small flex items-center gap-1 text-secondary-foreground"
          type="button"
        >
          Show details
          <CircleHelp aria-hidden size={14} />
        </button>
      </DialogTrigger>
      <DialogContent className="overflow-y-auto">
        <DialogTitle>Details</DialogTitle>
        <DialogDescription className="sr-only">Details for {title}</DialogDescription>
        <p className="typography-small-headline">{title}</p>
        <dl className="mt-8 space-y-8">
          {drivers.map(driver => (
            <div key={driver.id}>
              <dt className="typography-text-small-bold">{driver.label}</dt>
              <dd className="typography-text-small mt-1">{driver.value}</dd>
              {driver.description ? (
                <dd className="typography-text-small mt-1 text-muted-foreground">
                  {driver.description}
                </dd>
              ) : null}
            </div>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
